import useEncryptedURLState from 'hooks/useEncryptedURLState';

export default function useHandleFilterChange(defaultFilter = {}) {
  const [fileManagerFilters, setFileManagerFilters] = useEncryptedURLState('filter', defaultFilter);

  function onFilterChange(e, clearBreadcrumbs = () => {}) {
    if (!e?.value?.id || !e?.value) {
      clearBreadcrumbs();
    }
    setFileManagerFilters((prevValues) => ({
      ...prevValues,
      [e?.target?.name]: e?.target?.value || e?.value,
      // Handle shared_folder flag inheritance for folder navigation
      // If shared_folder is explicitly set to false (bypass for shared folders), use that
      // Otherwise, handle normal inheritance logic
      ...(e?.shared_folder !== undefined
        ? { shared_folder: e.shared_folder }
        : e?.target?.name === 'selectedFolder' && prevValues.shared_folder
        ? { shared_folder: prevValues.shared_folder }
        : {}),
      ...(e.hasOwnProperty('shared_contact_list')
        ? e.shared_contact_list !== null
          ? { shared_contact_list: e.shared_contact_list }
          : { shared_contact_list: undefined }
        : e?.target?.name === 'selectedFolder' && prevValues.shared_contact_list
        ? { shared_contact_list: prevValues.shared_contact_list }
        : {}),
      ...(e.hasOwnProperty('folder_shared')
        ? e.folder_shared !== null
          ? { folder_shared: e.folder_shared }
          : { folder_shared: undefined }
        : e?.target?.name === 'selectedFolder' && prevValues.folder_shared
        ? { folder_shared: prevValues.folder_shared }
        : {}),
      ...(e.hasOwnProperty('folder_type') ? (e.folder_type !== null ? { folder_type: e.folder_type } : { folder_type: undefined }) : {}),
      ...(e.hasOwnProperty('is_virtual') ? (e.is_virtual !== null ? { is_virtual: e.is_virtual } : { is_virtual: undefined }) : {}),
      ...(e.hasOwnProperty('is_system_folder')
        ? e.is_system_folder !== null
          ? { is_system_folder: e.is_system_folder }
          : { is_system_folder: undefined }
        : {}),
    }));
  }
  function onTagChange(e) {
    setFileManagerFilters((prevValues) => ({
      ...prevValues,
      [e.target.name]: e.value,
    }));
  }

  return { fileManagerFilters, onFilterChange, onTagChange, setFileManagerFilters };
}
